module.exports = __webpack_public_path__ + "img/palmar-room-8.176b5c6b.jpg";